var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 0L9.885 2.115L18.255 10.5H0L0 13.5H18.255L9.885 21.885L12 24L24 12L12 0Z","fill":"#00903C"}})])}
var staticRenderFns = []

export { render, staticRenderFns }